import { IPurchaseState, IPurchaseStateWithCustomerRelationship } from "@smartrr/shared/entities/PurchaseState";
import { IPurchaseStateLineItem } from "@smartrr/shared/entities/PurchaseState/CustomerPurchaseLineItem";
import { useEffect, useState } from "react";

import { updateInvalidVariantModal } from "@vendor-app/app/_state/actionCreators/subscriptionDetails";
import { useSmartrrVendorDispatch } from "@vendor-app/app/_state/typedVendorReduxHooks";

import { useSubscriptionPurchasables } from "../../providers/SubscriptionPurchasablesProvider";

const PURCHASE_STATES_TO_CHECK: IPurchaseState["purchaseStateStatus"][] = ["ACTIVE", "PAUSED"];

export const useLineItemWithDeletedVariant = (
  customerPurchaseState: IPurchaseStateWithCustomerRelationship | undefined
) => {
  const [lineItemWithDeletedVariant, setLineItemWithDeletedVariant] = useState<IPurchaseStateLineItem | null>(
    null
  );
  const { variantToPurchasableMap, isFetching, hasLoaded } = useSubscriptionPurchasables();
  const dispatch = useSmartrrVendorDispatch();

  useEffect(() => {
    if (!hasLoaded || isFetching) {
      return;
    }

    if (customerPurchaseState && PURCHASE_STATES_TO_CHECK.includes(customerPurchaseState.purchaseStateStatus)) {
      //if variant is deleted open the modal
      if (customerPurchaseState.stLineItems.filter(li => !li.vnt).length) {
        setLineItemWithDeletedVariant(customerPurchaseState.stLineItems.find(item => !item.vnt) ?? null);

        dispatch(updateInvalidVariantModal(true));
        return;
      }
      //if product is deleted (cant find product in variantToPurchasableMap) open the modal
      if (customerPurchaseState.stLineItems.some(li => variantToPurchasableMap[li.vnt.id] === undefined)) {
        setLineItemWithDeletedVariant(
          customerPurchaseState.stLineItems.find(li => variantToPurchasableMap[li.vnt.id] === undefined) ?? null
        );
        dispatch(updateInvalidVariantModal(true));
        return;
      }
      //if deleted product/variant was removed/replaced in the subscription
      if (lineItemWithDeletedVariant) {
        setLineItemWithDeletedVariant(null);
      }
    }
  }, [
    customerPurchaseState?.stLineItems,
    variantToPurchasableMap,
    lineItemWithDeletedVariant,
    hasLoaded,
    isFetching,
  ]);

  return lineItemWithDeletedVariant;
};
